import { render } from "./file-overview.vue?vue&type=template&id=ee571a0a"
import script from "./file-overview.vue?vue&type=script&lang=js"
export * from "./file-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__